const NotificationAudienceEnum = Object.freeze({
    USERS: 'USERS',
    CLIENTS: 'CLIENTS'
});

export default NotificationAudienceEnum;
